/* ============================================
   CANDLE CUSTOMIZER v2 - Harvest Sunset Candles
   Dynamic Categories & Labels via Theme Editor Blocks
   ============================================ */

(function() {
  'use strict';

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    initAllCustomizers();
  });

  // Re-initialize when Shopify Theme Editor refreshes the section
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-hsc-customizer]')) {
      initAllCustomizers();
    }
  });

  function initAllCustomizers() {
    var customizerEl = document.querySelector('[data-hsc-customizer]');
    if (!customizerEl) return;

    if (customizerEl.dataset.initialized === 'true') return;
    customizerEl.dataset.initialized = 'true';

    var config = window.CandleCustomizerConfig || {};
    initCandleCustomizer(customizerEl, config);
  }

  function initCandleCustomizer(container, config) {
    /* ============================================
       CONFIGURATION
       ============================================ */
    var categories = config.categories || [];
    var scents = (config.scents || []).slice().sort(function(a, b) {
      return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    });
    var variantId = config.variantId || null;
    var isTestMode = config.testMode !== false;

    // Flatten labels for easy lookup
    var allLabels = [];
    categories.forEach(function(cat) {
      cat.labels.forEach(function(label) {
        label.categoryId = cat.id;
        label.categoryName = cat.name;
        allLabels.push(label);
      });
    });

    /* ============================================
       STATE
       ============================================ */
    var state = {
      currentTab: 1,
      previewSlide: 0,
      category: null,
      label: null,
      scent: null,
      textColor: null,
      fields: {}
    };

    /* ============================================
       DOM ELEMENTS
       ============================================ */
    var elements = {
      tabs: container.querySelector('[data-tabs]'),
      typeOptions: container.querySelector('[data-type-options]'),
      labelOptions: container.querySelector('[data-label-options]'),
      dynamicFields: container.querySelector('[data-dynamic-fields]'),
      scentSelect: container.querySelector('[data-scent-select]'),
      previewJar: container.querySelector('[data-preview-jar]'),
      previewDesign: container.querySelector('[data-preview-design]'),
      previewPrev: container.querySelector('[data-preview-prev]'),
      previewNext: container.querySelector('[data-preview-next]'),
      previewCaption: container.querySelector('[data-preview-caption]'),
      summaryContainer: container.querySelector('[data-summary-fields]'),
      summaryCandleType: container.querySelector('[data-summary-type]'),
      summaryLabel: container.querySelector('[data-summary-label]'),
      summaryScent: container.querySelector('[data-summary-scent]'),
      addToCartBtn: container.querySelector('[data-add-to-cart]'),
      debugOutput: container.querySelector('[data-debug-output]')
    };

    /* ============================================
       INITIALIZATION
       ============================================ */
    function init() {
      if (categories.length === 0) {
        container.innerHTML = '<p style="text-align:center;padding:40px;color:#666;">No categories configured. Add Category blocks in the Theme Editor.</p>';
        return;
      }

      renderCategoryOptions();
      renderLabelOptions();
      renderScentOptions();
      setupEventListeners();
      setupTabListeners();
      setupInfoTabs();

      if (categories.length > 0) {
        selectCategory(categories[0].id);
      }

      goToTab(1);
      updatePreview();
      updateSummary();
      updateDebug();
    }

    /* ============================================
       TAB NAVIGATION
       ============================================ */
    function goToTab(tabNum) {
      state.currentTab = tabNum;

      // Update tab buttons
      container.querySelectorAll('.hsc-customizer__tab').forEach(function(tab) {
        tab.classList.toggle('is-active', tab.dataset.tab === String(tabNum));
      });

      // Update tab panels
      container.querySelectorAll('.hsc-customizer__tab-panel').forEach(function(panel) {
        panel.classList.toggle('is-active', panel.dataset.tabPanel === String(tabNum));
      });
    }

    function setupTabListeners() {
      // Tab button clicks
      if (elements.tabs) {
        elements.tabs.addEventListener('click', function(e) {
          var tab = e.target.closest('.hsc-customizer__tab');
          if (tab) {
            goToTab(parseInt(tab.dataset.tab, 10));
          }
        });
      }

      // Next / Back button clicks
      container.querySelectorAll('[data-goto-tab]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          goToTab(parseInt(btn.dataset.gotoTab, 10));
        });
      });
    }

    /* ============================================
       RENDER FUNCTIONS
       ============================================ */
    function renderCategoryOptions() {
      if (!elements.typeOptions) return;

      elements.typeOptions.innerHTML = categories.map(function(cat) {
        return '<button type="button" class="hsc-customizer__type-btn" data-category="' + cat.id + '">' +
          '<span class="hsc-customizer__type-name">' + cat.name + '</span>' +
          (cat.description ? '<span class="hsc-customizer__type-description">' + cat.description + '</span>' : '') +
        '</button>';
      }).join('');
    }

    function renderLabelOptions() {
      if (!elements.labelOptions) return;

      elements.labelOptions.innerHTML = allLabels.map(function(label) {
        var hasImage = label.thumbnail || label.image;
        var bgStyle = hasImage ? 'background-image: url(\'' + (label.thumbnail || label.image) + '\')' : '';
        var placeholderClass = !hasImage ? ' hsc-customizer__placeholder-label' : '';

        return '<div class="hsc-customizer__label-option' + placeholderClass + '" ' +
          'data-label="' + label.id + '" ' +
          'data-category="' + label.categoryId + '" ' +
          'style="' + bgStyle + '" ' +
          'title="' + label.name + '">' +
          (!hasImage ? '<span>' + label.name + '</span>' : '') +
        '</div>';
      }).join('');
    }

    function renderScentOptions() {
      if (!elements.scentSelect) return;

      var optionsHtml = '<option value="">-- Choose a scent --</option>';
      scents.forEach(function(scent) {
        optionsHtml += '<option value="' + scent.value + '">' + scent.name + '</option>';
      });
      elements.scentSelect.innerHTML = optionsHtml;
    }

    function renderDynamicFields(labelId) {
      if (!elements.dynamicFields) return;

      var selectedLabel = allLabels.find(function(l) { return l.id === labelId; });
      if (!selectedLabel) {
        elements.dynamicFields.innerHTML = '<p class="hsc-customizer__no-fields">Select a label design first.</p>';
        return;
      }

      var fields = selectedLabel.fields || [];
      var labelColors = selectedLabel.colors || [];
      state.fields = {};

      var html = '';

      if (fields.length === 0 && labelColors.length === 0) {
        html = '<p class="hsc-customizer__no-fields">This label has no personalization options.</p>';
      } else {
        html = fields.map(function(field) {
          var fieldHtml = '<div class="hsc-customizer__field">';
          fieldHtml += '<label class="hsc-customizer__field-label" for="field-' + field.id + '">' + field.label;
          if (field.maxLength) {
            fieldHtml += ' <span class="hsc-customizer__field-limit">(max ' + field.maxLength + ' chars)</span>';
          }
          fieldHtml += '</label>';
          fieldHtml += '<input type="text" class="hsc-customizer__field-input" id="field-' + field.id + '" ' +
            'data-field-id="' + field.id + '" ' +
            'data-field-label="' + field.label + '" ' +
            (field.maxLength ? 'maxlength="' + field.maxLength + '"' : '') + '>';
          if (field.maxLength) {
            fieldHtml += '<div class="hsc-customizer__char-count"><span data-count-' + field.id + '>0</span>/' + field.maxLength + '</div>';
          }
          fieldHtml += '</div>';
          return fieldHtml;
        }).join('');
      }

      // Text color picker from per-label color list
      if (labelColors.length > 0) {
        html += '<div class="hsc-customizer__field">';
        html += '<label class="hsc-customizer__field-label" for="field-textColor">Text Color</label>';
        html += '<select class="hsc-customizer__field-select" id="field-textColor" data-field-id="textColor" data-field-label="Text Color">';
        html += '<option value="">-- Select color --</option>';
        labelColors.forEach(function(color) {
          html += '<option value="' + color + '">' + color + '</option>';
        });
        html += '</select>';
        html += '</div>';
      }

      elements.dynamicFields.innerHTML = html;
      setupFieldListeners();
    }

    function setupFieldListeners() {
      var inputs = elements.dynamicFields.querySelectorAll('.hsc-customizer__field-input');
      inputs.forEach(function(input) {
        input.addEventListener('input', function(e) {
          var fieldId = e.target.dataset.fieldId;
          state.fields[fieldId] = {
            label: e.target.dataset.fieldLabel,
            value: e.target.value
          };

          var countEl = container.querySelector('[data-count-' + fieldId + ']');
          if (countEl) {
            countEl.textContent = e.target.value.length;
          }

          updateSummary();
          updateDebug();
        });
      });

      var selects = elements.dynamicFields.querySelectorAll('.hsc-customizer__field-select');
      selects.forEach(function(select) {
        select.addEventListener('change', function(e) {
          var fieldId = e.target.dataset.fieldId;
          if (fieldId === 'textColor') {
            state.textColor = e.target.value;
          } else {
            state.fields[fieldId] = {
              label: e.target.dataset.fieldLabel,
              value: e.target.value
            };
          }
          updateSummary();
          updateDebug();
        });
      });
    }

    function filterLabelsByCategory(categoryId) {
      var labelElements = container.querySelectorAll('.hsc-customizer__label-option');
      var firstVisible = null;

      labelElements.forEach(function(el) {
        var belongsToCategory = el.dataset.category === categoryId;
        el.classList.toggle('is-hidden', !belongsToCategory);

        if (belongsToCategory && !firstVisible) {
          firstVisible = el.dataset.label;
        }
      });

      var currentLabel = allLabels.find(function(l) { return l.id === state.label; });
      if (!currentLabel || currentLabel.categoryId !== categoryId) {
        if (firstVisible) {
          selectLabel(firstVisible);
        } else {
          state.label = null;
          renderDynamicFields(null);
        }
      }
    }

    /* ============================================
       EVENT LISTENERS
       ============================================ */
    function setupEventListeners() {
      if (elements.typeOptions) {
        elements.typeOptions.addEventListener('click', function(e) {
          var btn = e.target.closest('.hsc-customizer__type-btn');
          if (btn) {
            selectCategory(btn.dataset.category);
          }
        });
      }

      if (elements.labelOptions) {
        elements.labelOptions.addEventListener('click', function(e) {
          var option = e.target.closest('.hsc-customizer__label-option');
          if (option && !option.classList.contains('is-hidden')) {
            selectLabel(option.dataset.label);
          }
        });
      }

      if (elements.scentSelect) {
        elements.scentSelect.addEventListener('change', function(e) {
          state.scent = e.target.value;
          updateScentInfo();
          updateSummary();
          updateDebug();
        });
      }

      if (elements.addToCartBtn) {
        elements.addToCartBtn.addEventListener('click', handleAddToCart);
      }

      if (elements.previewPrev) {
        elements.previewPrev.addEventListener('click', function() {
          goToPreviewSlide(0);
        });
      }

      if (elements.previewNext) {
        elements.previewNext.addEventListener('click', function() {
          goToPreviewSlide(1);
        });
      }
    }

    /* ============================================
       SELECTION HANDLERS
       ============================================ */
    function selectCategory(categoryId) {
      state.category = categoryId;
      state.textColor = null;

      container.querySelectorAll('.hsc-customizer__type-btn').forEach(function(el) {
        el.classList.toggle('is-selected', el.dataset.category === categoryId);
      });

      filterLabelsByCategory(categoryId);
      updatePreview();
      updateSummary();
      updateDebug();
    }

    function selectLabel(labelId) {
      state.label = labelId;
      state.fields = {};
      state.textColor = null;

      container.querySelectorAll('.hsc-customizer__label-option').forEach(function(el) {
        el.classList.toggle('is-selected', el.dataset.label === labelId);
      });

      renderDynamicFields(labelId);
      updatePreview();
      updateSummary();
      updateDebug();
    }

    /* ============================================
       PREVIEW UPDATE
       ============================================ */
    function updatePreview() {
      var selectedLabel = allLabels.find(function(l) { return l.id === state.label; });
      var jarImage = config.jarImage;

      // Jar image (slide 0)
      if (elements.previewJar) {
        elements.previewJar.style.backgroundImage = jarImage ? 'url(\'' + jarImage + '\')' : 'none';
      }

      // Label image (slide 1)
      if (elements.previewDesign) {
        if (selectedLabel && selectedLabel.image) {
          elements.previewDesign.style.backgroundImage = 'url(\'' + selectedLabel.image + '\')';
          elements.previewDesign.classList.remove('hsc-customizer__placeholder-design');
          elements.previewDesign.innerHTML = '';
        } else if (selectedLabel) {
          elements.previewDesign.style.backgroundImage = 'none';
          elements.previewDesign.classList.add('hsc-customizer__placeholder-design');
          elements.previewDesign.innerHTML = '<span>' + selectedLabel.name + '</span>';
        } else {
          elements.previewDesign.style.backgroundImage = 'none';
          elements.previewDesign.classList.remove('hsc-customizer__placeholder-design');
          elements.previewDesign.innerHTML = '';
        }
      }

      // Update arrows without changing the current slide
      var hasJar = !!jarImage;
      var hasLabel = !!selectedLabel;
      var showArrows = hasJar && hasLabel;
      if (elements.previewPrev) {
        elements.previewPrev.classList.toggle('is-hidden', !showArrows || state.previewSlide === 0);
      }
      if (elements.previewNext) {
        elements.previewNext.classList.toggle('is-hidden', !showArrows || state.previewSlide === 1);
      }

      if (elements.previewCaption) {
        var categoryObj = categories.find(function(c) { return c.id === state.category; });
        var catName = categoryObj ? categoryObj.name : '';
        var labelName = selectedLabel ? selectedLabel.name : '';
        elements.previewCaption.textContent = labelName ? catName + ' \u2013 ' + labelName : 'Select options to see preview';
      }
    }

    function goToPreviewSlide(index) {
      state.previewSlide = index;
      var hasJar = !!config.jarImage;
      var hasLabel = !!state.label;

      container.querySelectorAll('.hsc-customizer__preview-slide').forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      var showArrows = hasJar && hasLabel;
      if (elements.previewPrev) {
        elements.previewPrev.classList.toggle('is-hidden', !showArrows || index === 0);
      }
      if (elements.previewNext) {
        elements.previewNext.classList.toggle('is-hidden', !showArrows || index === 1);
      }
    }

    /* ============================================
       SUMMARY UPDATE
       ============================================ */
    function updateSummary() {
      var categoryObj = categories.find(function(c) { return c.id === state.category; });
      var labelObj = allLabels.find(function(l) { return l.id === state.label; });
      var scentText = '';

      if (elements.scentSelect && state.scent) {
        var selectedOption = elements.scentSelect.options[elements.scentSelect.selectedIndex];
        if (selectedOption) scentText = selectedOption.text;
      }

      if (elements.summaryCandleType) {
        elements.summaryCandleType.textContent = categoryObj ? categoryObj.name : '-';
      }
      if (elements.summaryLabel) {
        elements.summaryLabel.textContent = labelObj ? labelObj.name : '-';
      }
      if (elements.summaryScent) {
        elements.summaryScent.textContent = state.scent ? scentText : 'Not selected';
      }

      if (elements.summaryContainer) {
        var html = '';

        Object.keys(state.fields).forEach(function(key) {
          var field = state.fields[key];
          if (field && field.value) {
            html += '<div class="hsc-customizer__summary-item">' +
              '<span class="hsc-customizer__summary-label">' + field.label + ':</span>' +
              '<span class="hsc-customizer__summary-value">' + field.value + '</span>' +
            '</div>';
          }
        });

        if (state.textColor) {
          html += '<div class="hsc-customizer__summary-item">' +
            '<span class="hsc-customizer__summary-label">Text Color:</span>' +
            '<span class="hsc-customizer__summary-value">' + state.textColor + '</span>' +
          '</div>';
        }

        elements.summaryContainer.innerHTML = html || '<div class="hsc-customizer__summary-item"><span class="hsc-customizer__summary-label">Personalization:</span><span class="hsc-customizer__summary-value">None</span></div>';
      }
    }

    /* ============================================
       DEBUG OUTPUT
       ============================================ */
    function updateDebug() {
      if (!elements.debugOutput) return;

      var categoryObj = categories.find(function(c) { return c.id === state.category; });
      var labelObj = allLabels.find(function(l) { return l.id === state.label; });
      var scentText = null;

      if (elements.scentSelect && state.scent) {
        var selectedOption = elements.scentSelect.options[elements.scentSelect.selectedIndex];
        if (selectedOption) scentText = selectedOption.text;
      }

      var lineItemProps = {
        'Candle Type': categoryObj ? categoryObj.name : null,
        'Label Design': labelObj ? labelObj.name : null,
        'Scent': scentText
      };

      Object.keys(state.fields).forEach(function(key) {
        var field = state.fields[key];
        if (field && field.value) {
          lineItemProps[field.label] = field.value;
        }
      });

      if (state.textColor) {
        lineItemProps['Text Color'] = state.textColor;
      }

      var output = {
        lineItemProperties: lineItemProps,
        state: state,
        variantId: variantId
      };

      elements.debugOutput.textContent = JSON.stringify(output, null, 2);
    }

    /* ============================================
       VALIDATION
       ============================================ */
    function validateFields() {
      var labelObj = allLabels.find(function(l) { return l.id === state.label; });
      if (!labelObj) return { valid: false, message: 'Please select a label design.' };

      var fields = labelObj.fields || [];
      var labelColors = labelObj.colors || [];
      var missing = [];

      fields.forEach(function(field) {
        var fieldData = state.fields[field.id];
        if (!fieldData || !fieldData.value || fieldData.value.trim() === '') {
          missing.push(field.label);
        }
      });

      if (labelColors.length > 0 && !state.textColor) {
        missing.push('Text Color');
      }

      if (missing.length > 0) {
        return { valid: false, message: 'Please fill in: ' + missing.join(', ') };
      }

      return { valid: true };
    }

    /* ============================================
       ADD TO CART
       ============================================ */
    function handleAddToCart() {
      if (!state.category) {
        alert('Please select a candle type.');
        goToTab(1);
        return;
      }

      if (!state.label) {
        alert('Please select a label design.');
        goToTab(2);
        return;
      }

      var validation = validateFields();
      if (!validation.valid) {
        alert(validation.message);
        goToTab(3);
        return;
      }

      if (!state.scent) {
        alert('Please select a scent to continue.');
        if (elements.scentSelect) elements.scentSelect.focus();
        return;
      }

      var categoryObj = categories.find(function(c) { return c.id === state.category; });
      var labelObj = allLabels.find(function(l) { return l.id === state.label; });

      var scentText = '';
      if (elements.scentSelect) {
        var selectedOption = elements.scentSelect.options[elements.scentSelect.selectedIndex];
        if (selectedOption) scentText = selectedOption.text;
      }

      var lineItemProperties = {
        'Candle Type': categoryObj ? categoryObj.name : '',
        'Label Design': labelObj ? labelObj.name : '',
        'Scent': scentText
      };

      Object.keys(state.fields).forEach(function(key) {
        var field = state.fields[key];
        if (field && field.value) {
          lineItemProperties[field.label] = field.value;
        }
      });

      if (state.textColor) {
        lineItemProperties['Text Color'] = state.textColor;
      }

      console.log('Add to cart with properties:', lineItemProperties);

      if (variantId && !isTestMode) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: lineItemProperties
          })
        })
        .then(function(response) {
          return response.json().then(function(data) {
            return { ok: response.ok, status: response.status, data: data };
          });
        })
        .then(function(result) {
          if (!result.ok) {
            console.error('Cart add failed:', result.status, result.data);
            var msg = result.data && (result.data.description || result.data.message) || 'Unknown error';
            alert('Could not add to cart:\n\n' + msg + '\n\n(HTTP ' + result.status + ' — check the Shopify product is active, in stock, and that the Variant ID in section settings matches.)');
            return;
          }
          console.log('Added to cart:', result.data);
          window.location.href = '/cart';
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          alert('Network error adding to cart:\n\n' + (error && error.message ? error.message : error));
        });
      } else if (!variantId) {
        alert('Add to Cart is not configured: the Product Variant ID is empty in the Theme Editor section settings. Set it to the variant ID of the Custom Candle product (e.g. 47309784252579).');
      } else {
        alert(
          'Test Mode: Add to Cart\n\n' +
          'Line Item Properties:\n' +
          JSON.stringify(lineItemProperties, null, 2) +
          '\n\nVariant ID: ' + (variantId || 'Not configured')
        );
      }
    }

    /* ============================================
       INFO ACCORDION (Description / Details / Scent Notes)
       Single-open: clicking a closed section opens it and closes others;
       clicking the open section closes it.
       ============================================ */
    function setupInfoTabs() {
      var accordion = document.querySelector('[data-info-tabs]');
      if (!accordion) return;

      var items = accordion.querySelectorAll('.hsc-info-accordion__item');

      items.forEach(function(item) {
        var header = item.querySelector('.hsc-info-accordion__header');
        if (!header) return;
        header.addEventListener('click', function() {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function(other) {
            other.classList.remove('is-open');
            var otherHeader = other.querySelector('.hsc-info-accordion__header');
            if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('is-open');
            header.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    function updateScentInfo() {
      var infoTabs = document.querySelector('[data-info-tabs]');
      if (!infoTabs) return;

      ['description', 'details', 'notes'].forEach(function(kind) {
        var attr = 'data-scent-' + kind;
        var defaultAttr = 'data-scent-' + kind + '-default';
        var defaultPane = infoTabs.querySelector('[' + defaultAttr + ']');
        var allPanes = infoTabs.querySelectorAll('[' + attr + ']');
        var match = state.scent ? infoTabs.querySelector('[' + attr + '="' + state.scent + '"]') : null;

        allPanes.forEach(function(p) { p.hidden = true; });

        if (match) {
          match.hidden = false;
          if (defaultPane) defaultPane.hidden = true;
        } else {
          if (defaultPane) defaultPane.hidden = false;
        }
      });
    }

    init();
  }

})();
